var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMicrosoftAzure(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 91 91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient-2);}.cls-2{fill:rgba(255,255,255,.44);stroke:#fff;stroke-miterlimit:10;}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:#0078d4;}.cls-5{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1155.83,
    y1: -47.03,
    x2: -1166.39,
    y2: -15.83,
    gradientTransform: "translate(1848.33 97.43) scale(1.56)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#114a8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0669bc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -1152.53,
    y1: -32.49,
    x2: -1154.98,
    y2: -31.66,
    gradientTransform: "translate(1848.33 97.43) scale(1.56)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#000",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#000",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#000",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -1153.8,
    y1: -47.96,
    x2: -1142.21,
    y2: -17.08,
    gradientTransform: "translate(1848.33 97.43) scale(1.56)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3ccbf4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2892df"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect6798",
    className: "cls-2",
    x: 0.5,
    y: 0.5,
    width: 90,
    height: 90
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M36.55,20.2h15.89l-16.49,48.87c-.35,1.03-1.31,1.72-2.4,1.72h-12.37c-1.4,0-2.53-1.13-2.53-2.53,0-.28,.04-.55,.13-.81l15.37-45.53c.35-1.03,1.31-1.72,2.4-1.72h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M59.64,52.98h-25.2c-.64,0-1.17,.52-1.17,1.16,0,.32,.13,.63,.37,.85l16.19,15.11c.47,.44,1.09,.68,1.74,.68h14.27l-6.2-17.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.55,20.2c-1.1,0-2.08,.71-2.41,1.76l-15.34,45.46c-.47,1.31,.21,2.76,1.52,3.23,.28,.1,.57,.15,.86,.15h12.69c.96-.17,1.76-.85,2.08-1.77l3.06-9.02,10.93,10.19c.46,.38,1.03,.59,1.63,.59h14.21l-6.23-17.82h-18.17l11.12-32.78h-15.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M56.85,21.92c-.35-1.03-1.31-1.72-2.4-1.72h-17.71c1.09,0,2.05,.69,2.4,1.72l15.37,45.54c.45,1.32-.26,2.76-1.59,3.21-.26,.09-.53,.13-.81,.13h17.71c1.4,0,2.53-1.13,2.53-2.53,0-.27-.04-.55-.13-.81l-15.37-45.54Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftAzure);
export default __webpack_public_path__ + "static/media/microsoftAzure.3bfe15bb62e0c7b4099fb4771f4a16e8.svg";
export { ForwardRef as ReactComponent };